/**
 * Nota sob «Limites de tom» (A-43, noturna 04/Set/2026).
 *
 * O gestor editava limites de tom esperando mudar como a IA se apresenta — e nada mudava.
 * Medido [lab]: a apresentação («atendente virtual» ou não) vem de `Tenant.aiSelfPresentsAsVirtual`,
 * lida pelo conductor, e prevalece quando as duas diretivas falam da mesma coisa. Essa config
 * tem **0 consumidores no front** e não entra no PATCH de config do tenant — só na base (A-54).
 * Enquanto não houver tela, a nota diz isso em vez de apontar para um lugar que não existe.
 */
export const TONE_LIMITS_NOTE =
  'Como a IA se apresenta ao cliente (se diz que é atendente virtual) não se define aqui: é uma configuração do tenant, que prevalece sobre estes limites. Essa configuração ainda não tem tela — hoje só se altera pela base.';

export function ToneLimitsNote(): JSX.Element {
  return (
    <p className="pe-note pe-note--warning" role="note" data-testid="tone-limits-note">
      {TONE_LIMITS_NOTE}
    </p>
  );
}
